// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__d8ICw","inputWrap":"Table_inputWrap__2HBSR","col":"Table_col__1UK2a","bmiTooltip":"Table_bmiTooltip__1nfjK"};